import React from 'react';

import { ILectureSearchResult } from 'services';
import { updateUrlSearchParameters } from 'global.helpers';

import './LectureSearchResultItem.scss';

/**
 * LectureSearchResultItem
 *
 * @description Component used to render search result
 */
const LectureSearchResultItem: React.FC<{ result: ILectureSearchResult; setSelectedVideo: React.Dispatch<string | null>; }> = ({ result, setSelectedVideo }) => {
  return (
    <article key={result.id} className='library-lecture-search__result-item' >
      <button
        className='library-lecture-search__video-button'
        type='button'
        onClick={() => {
          setSelectedVideo(result.id);
          updateUrlSearchParameters('selectedVideo', result.id);
        }}
      >
        <div className='library-lecture-search__video-thumbnail'>
          <img
            src={result.imageUrl}
            alt={result.imageAltText ? result.imageAltText : result.title}
          />
        </div>

        <span>{result.title}</span>
      </button>
      <aside>{result.durationString}</aside>
    </article>
  );
};

export default LectureSearchResultItem;